import React from 'react';

const Footer = ({
  email = 'likessayomuma@gmail.com',
  year = new Date().getFullYear()
}) => {
  return (
    <footer className="bg-hero-bg text-text-white py-12 lg:py-16">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* CTA Section */}
        <div className="text-center mb-10 lg:mb-12">
          <p className="text-xl sm:text-2xl lg:text-3xl font-semibold text-white mb-2">
            Let's Co-Create!
          </p>
          <p className="text-base sm:text-lg text-gray-300 max-w-2xl mx-auto">
            Reach out to us to discuss how we can work together to achieve lasting impact.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center lg:items-end justify-between gap-8">
          <div className="text-center lg:text-left">
            <h2 className="text-xl sm:text-2xl font-semibold">Privacy Policy</h2>
            <p className="text-sm sm:text-base text-gray-300 mt-2">
              Have a question or want to explore collaboration?
            </p>
            <p className="text-sm sm:text-base text-gray-100 font-medium mt-1">
              Email: <a href={`mailto:${email}`} className="hover:text-accent-yellow transition-colors">{email}</a>
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/in/yomuma-likessa-292679162"
              target="_blank"
              rel="noopener noreferrer"
              className="h-10 w-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center hover:bg-white/20 transition-all duration-200"
              aria-label="LinkedIn profile"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5 text-white">
                <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11.75 20h-2.5v-11h2.5v11zm-1.25-12.52c-.8 0-1.45-.65-1.45-1.45s.65-1.45 1.45-1.45 1.45.65 1.45 1.45-.65 1.45-1.45 1.45zm13 12.52h-2.5v-5.75c0-1.37-.03-3.13-1.91-3.13-1.91 0-2.2 1.49-2.2 3.03v5.85h-2.5v-11h2.4v1.5h.03c.33-.62 1.13-1.27 2.33-1.27 2.5 0 2.96 1.65 2.96 3.79v6.98z"/>
              </svg>
            </a>
            <a
              href={`mailto:${email}`}
              className="h-10 w-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center hover:bg-white/20 transition-all duration-200"
              aria-label="Email"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="h-5 w-5 text-white">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <path d="M22 6l-10 7L2 6" />
              </svg>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/20 text-center">
          <p className="text-sm text-gray-300">
            © {year} Yomuma Likessa Daba. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
